module.exports = __webpack_public_path__ + "img/akfel-wgc-paris-multitouch-application-02.46bd2433.jpg";